<template>
  <div class="slider-cont">
    <div class="ellipse-one wow"></div>
    <div class="ellipse-two wow"></div>
    <Navbar/>

    <div class="container">
      <div class="content">
        <div class="row">
          <div class="col-md-6 ">
            <div class="theimgg slid-co wow">
              <div class="owl-carousel owl-theme">
                <div class="cont">
                  <img
                      src="@/assets/gvLearning/img/little-man-reading-among-large-books-textbooks-scale-effect-gaining-knowledge-education-concept-student-studying-subject-before-exam-1.png">
                </div>
                <div class="cont">
                  <img
                      src="@/assets/gvLearning/img/unsplash_7fF0iei80AQ.png">
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6 ">
            <div class="disc wow">
              <h3>Learning<br>Without limits</h3>
              <p>GV Leraning is the tool to changing lives, uplift businesses, and upskill nations.<br>Transforming life
                through technologies & education.</p>
              <a class="book wow" href="#">
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <span>Book a demo</span>
                <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M19.7709 4.44699C19.7706 4.44676 19.7704 4.44648 19.7702 4.44625L15.688 0.383747C15.3821 0.0794115 14.8875 0.0805441 14.5831 0.386403C14.2787 0.692224 14.2799 1.18687 14.5857 1.49125L17.3265 4.21875H0.78125C0.349766 4.21875 0 4.56851 0 5C0 5.43148 0.349766 5.78125 0.78125 5.78125H17.3264L14.5857 8.50875C14.2799 8.81312 14.2788 9.30777 14.5831 9.61359C14.8875 9.91949 15.3822 9.92054 15.688 9.61625L19.7702 5.55375C19.7704 5.55351 19.7706 5.55324 19.7709 5.55301C20.0769 5.24761 20.0759 4.75136 19.7709 4.44699Z"
                      fill="white"/>
                </svg>
              </a>
              <a href="#" class="try wow">
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <div class='line'></div>
                <span>Try GV Business</span>
              </a>
            </div>

          </div>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import $ from "jquery";
import 'owl.carousel';
import Navbar from "@/components/gvLearning/Navbar";

export default {
  components: {Navbar},
  mounted() {
    this.$nextTick(() => {
      this.installOwlCarousel()
    })
  },
  methods: {
    installOwlCarousel: function () {
      window.fn = require('owl.carousel');
      $('.owl-carousel').owlCarousel(
          {
            loop: true,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            dots: false,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
              0: {
                items: 1
              },
              400: {
                items: 1
              },
              740: {
                items: 1
              },
              940: {
                items: 1
              }
            },
            nav: true
          }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/gvLearning/styles.scss";

.slider-cont {
  background: #003827;
  position: relative;
  padding-bottom: 134px;
  overflow: hidden;
  @media (min-width: $width1) and (max-width: $width2) {
    padding-bottom: 0px;
    height: 635px;

  }

  .ellipse-one {
    position: absolute;
    top: -1102px;
    left: -626px;
    width: 86%;
    height: 166%;
    background: radial-gradient(38.86% 38.86% at 50% 50%, #00E384 0%, rgba(26, 25, 29, 0) 100%);
    animation: fadeInLeft;
    animation-duration: 5s;

  }

  .ellipse-two {
    position: absolute;
    top: 0%;
    right: -1006px;
    width: 98%;
    height: 100%;
    background: radial-gradient(38.86% 38.86% at 50% 50%, #00E384 0%, rgba(26, 25, 29, 0) 100%);
    animation: fadeInRight;
    animation-duration: 5s;
  }

  .container {
    @media (min-width: $width1) and (max-width: $width2) {
      padding: 0;
    }

    .content {
      padding: 100px 0;
      @media (min-width: $width1) and (max-width: $width2) {
        padding: 42px 0 0;
      }

      .row {
        @media (min-width: $width1) and (max-width: $width2) {
          flex-direction: column-reverse;

        }

        .theimgg {
          width: 100%;
          mix-blend-mode: screen;
          border-radius: 122px;
          animation: slideInLeft;
          animation-duration: 3s;
          @media (min-width: $width1) and (max-width: $width2) {
            position: relative;
            top: -127px;
            border-radius: 0px;

          }

        }


        .disc {
          padding: 90px 80px 90px 100px;
          animation: slideInRight;
          animation-duration: 3s;
          @media (min-width: $width1) and (max-width: $width2) {
            padding: 20px 26px;
          }

          h3 {
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 52px;
            line-height: 69px;
            text-align: justify;
            color: #FFFFFF;
            @media (min-width: $width1) and (max-width: $width2) {
              font-size: 32px;
              line-height: 44px;
              margin-bottom: 16px;
            }


          }

          p {
            font-family: Roboto;
            font-style: normal;
            font-weight: 300;
            font-size: 20px;
            line-height: 131%;
            /* or 31px */
            color: #FFFFFF;
            opacity: 0.7;
            margin-bottom: 52px;
            @media (min-width: $width1) and (max-width: $width2) {
              font-style: normal;
              font-size: 14px;
              margin-bottom: 36px;
            }

          }

          .book {
            background: linear-gradient(90deg, #00FF85 0%, rgba(0, 255, 133, 0) 222.91%);
            border-radius: 2px;
            text-decoration: none;
            color: #FFF;
            padding: 10px 24px;
            font-size: 16px;
            transition: all 2s;
            border: linear-gradient(90deg, #00FF85 0%, rgba(0, 255, 133, 0) 222.91%);
            display: inline-block;
            position: relative;
            animation: bounceInRight;
            animation-duration: 4s;

            @media (min-width: $width1) and (max-width: $width2) {
              padding: 10px 12px;
              font-size: 13px;
            }


            .line {
              background: #003827;
              position: absolute;
              transition: none;
              transform: scale(0);
              opacity: 1;
              height: $line-size;
            }


            .line:nth-child(1) {
              transform-origin: 100% 100%;
              width: 20%;
              bottom: 0;
            }


            .line:nth-child(4) {
              transform-origin: 0 100%;
              width: 20%;
              top: $distance;
              right: 0;
            }


            .line:nth-child(2) {
              transform-origin: 100% 100%;
              height: 100%;
              bottom: 0;
              left: $distance;
            }


            .line:nth-child(5) {
              transform-origin: 100% 0;
              height: 100%;
              bottom: 0;
              right: $distance;
            }


            .line:nth-child(3) {
              transform-origin: 0 100%;
              width: 100%;
              top: $distance;
              left: $distance;
            }


            .line:nth-child(6) {
              transform-origin: 100% 0;
              width: 100%;
              bottom: 0;
              right: $distance;
            }

            &:hover > .line {
              transform: scale(1);
              opacity: 0;
              transition: all 1s;
            }

            &:hover > .line:nth-child(2), &:hover > .line:nth-child(5) {
              transition-delay: $delay1;
            }

            &:hover > .line:nth-child(3), &:hover > .line:nth-child(6) {
              transition-delay: $delay2;
            }


            svg {
              margin-left: 12px;
              @media (min-width: $width1) and (max-width: $width2) {
                margin-left: 9px;
                width: 16px;
                height: 15px;
              }
            }
          }

          .try {
            @extend .book;
            padding: 9px 24px;
            background: unset;
            margin-left: 15px;
            border: 10px solid;
            border-image-slice: 1;
            border-width: 1px;
            animation: bounceInRight;
            animation-duration: 4.5s;
            border-image-source: linear-gradient(to right, #00FF85, #003827);
            @media (min-width: $width1) and (max-width: $width2) {
              padding: 9px 12px;
              margin-left: 13px;
            }

            .line {
              background: #FFF;
              position: absolute;
              transition: none;
              transform: scale(0);
              opacity: 1;
              height: 1px;
              z-index: 999;
            }

          }
        }
      }

    }

  }
}
</style>
